<script>
    import success from "./stores/success";
</script>

    <div class="success-message" class:visible={$success.visible}>
        {@html $success.message}
    </div>

<style>
    .success-message.visible {
        transform: translateX(-50%) translateY(0);
    }
    .success-message {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%) translateY(-100%);
        transition: .2s;
        color: #fff;
        background: black;
        border-radius: 4px;
        padding: 0 20px;
        z-index: 9999;
        width: max-content;
        max-width: 80%;
    }
    .success-message .success-prompt {
        padding: 10px;
        z-index: 9999;
    }

    @media (max-width: 575px) {
        .success-message {
            text-align: center;
            width: 95%;
            max-width: 95%;
        }
    }
</style>